import baseAPI from '../app/axios';

export default class ECBindingService {
  static async getData(orgId, provider) {
    if (!orgId) {
      throw new Error('ECBindingService.getData: orgId undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.getData: provider undefined');
    }

    const response = await baseAPI.get(`/ec/${provider}?orgId=${orgId}`);

    return response || {};
  }

  static async saveData(orgId, provider, data) {
    if (!orgId) {
      throw new Error('ECBindingService.saveData: orgId undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.saveData: provider undefined');
    }

    if (!data) {
      throw new Error('ECBindingService.saveData: data undefined');
    }

    const response = await baseAPI.patch(`/ec/${provider}`, {
      orgId,
      ...data,
    });

    return response;
  }

  static async connect(orgId, provider, data) {
    if (!orgId) {
      throw new Error('ECBindingService.connect: orgId undefined');
    }

    if (!data) {
      throw new Error('ECBindingService.connect: data undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.connect: provider undefined');
    }

    const response = await baseAPI.post(`/ec/${provider}/connect`, {
      orgId,
      ...data,
    });

    return response;
  }

  static async disconnect(orgId, provider) {
    if (!orgId) {
      throw new Error('ECBindingService.disconnect: orgId undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.disconnect: provider undefined');
    }

    const response = await baseAPI.post(`/ec/${provider}/disconnect`, {
      orgId,
    });

    return response;
  }

  static async getDisplayData(orgId, provider, token) {
    if (!orgId) {
      throw new Error('ECBindingService.getDisplayData: orgId undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.getDisplayData: provider undefined');
    }

    if (!token) {
      throw new Error('ECBindingService.getDisplayData: token undefined');
    }

    const response = await baseAPI.get(
      `/ec/${provider}/display?orgId=${orgId}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  }

  static async sendVerification(orgId, account, customerId, token, provider) {
    if (!orgId) {
      throw new Error('ECBindingService.sendVerification: orgId undefined');
    }

    if (!account) {
      throw new Error('ECBindingService.sendVerification: account undefined');
    }

    if (!customerId) {
      throw new Error(
        'ECBindingService.sendVerification: customerId undefined',
      );
    }

    if (!token) {
      throw new Error('ECBindingService.sendVerification: token undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.sendVerification: provider undefined');
    }

    const response = await baseAPI.post(
      `/ec/${provider}/sendVerification`,
      {
        orgId,
        account,
        customerId,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  }

  static async bind(
    orgId,
    customerId,
    ecCustomerId,
    authCode,
    token,
    provider,
  ) {
    if (!orgId) {
      throw new Error('ECBindingService.bind: orgId undefined');
    }

    if (!customerId) {
      throw new Error('ECBindingService.bind: customerId undefined');
    }

    if (!ecCustomerId) {
      throw new Error('ECBindingService.bind: ecCustomerId undefined');
    }

    if (!authCode) {
      throw new Error('ECBindingService.bind: authCode undefined');
    }

    if (!token) {
      throw new Error('ECBindingService.bind: token undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.bind: provider undefined');
    }

    const response = await baseAPI.post(
      `/ec/${provider}/bindCustomer`,
      {
        orgId,
        customerId,
        ecCustomerId,
        authCode,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  }

  static async searchCustomers(
    orgId,
    customerId,
    account,
    authCode,
    token,
    provider,
  ) {
    if (!orgId) {
      throw new Error('ECBindingService.searchCustomers: orgId undefined');
    }

    if (!customerId) {
      throw new Error('ECBindingService.searchCustomers: customerId undefined');
    }

    if (!account) {
      throw new Error('ECBindingService.searchCustomers: account undefined');
    }

    if (!authCode) {
      throw new Error('ECBindingService.searchCustomers: authCode undefined');
    }

    if (!token) {
      throw new Error('ECBindingService.searchCustomers: token undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.searchCustomers: provider undefined');
    }

    const response = await baseAPI.post(
      `/ec/${provider}/searchCustomers`,
      {
        orgId,
        customerId,
        account,
        authCode,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  }

  static async checkIsBind(orgId, customerId, token, provider) {
    if (!orgId) {
      throw new Error('ECBindingService.checkIsBind: orgId undefined');
    }

    if (!customerId) {
      throw new Error('ECBindingService.checkIsBind: customerId undefined');
    }

    if (!token) {
      throw new Error('ECBindingService.checkIsBind: token undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.checkIsBind: provider undefined');
    }

    const response = await baseAPI.get(
      `/ec/${provider}/customer?orgId=${orgId}&customerId=${customerId}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.id;
  }

  static async cancelBind(orgId, customerId, token, provider) {
    if (!orgId) {
      throw new Error('ECBindingService.cancelBind: orgId undefined');
    }

    if (!customerId) {
      throw new Error('ECBindingService.cancelBind: customerId undefined');
    }

    if (!token) {
      throw new Error('ECBindingService.cancelBind: token undefined');
    }

    if (!provider) {
      throw new Error('ECBindingService.cancelBind: provider undefined');
    }

    const response = await baseAPI.post(
      `/ec/${provider}/bindCancel`,
      {
        orgId,
        customerId,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  }

  static async createLineLiff(orgId, liffName) {
    const response = await baseAPI.patch('/integration/line/liff', {
      orgId,
      liffName,
    });

    return response || {};
  }

  static async deleteLineLiff(orgId, liffName) {
    const response = await baseAPI.request({
      method: 'delete',
      url: `/integration/line/liff`,
      data: { orgId, liffName },
    });

    return response || {};
  }
}
